import React from 'react';

const QuoteBuilderLayout = ({ drawing, children }) => {
  return (
    <div className="card" style={{ margin: '10px' }}>
      <div className="row">
        <div className="col-6">
          <div style={{ margin: '20px' }}>
            {drawing.image !== undefined && (
              <img src={drawing.image.three_d_image_url} width="200" alt="3D Preview" />
            )}
          </div>
        </div>
        <div className="col-5">
          <br />
          <h3 style={{ textAlign: 'center' }}>{t('quote_builder_widget.get_a_quote')}</h3>
          <br />
          {children}
        </div>
      </div>
    </div>
  );
};

export default QuoteBuilderLayout;
